import { motion } from 'framer-motion';

export default function Logo({ size = 28, withText = true, className = '' }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="tsf-logo">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        className="relative"
        style={{ width: size, height: size }}
      >
        <div
          className="rounded-full"
          style={{
            width: size, height: size,
            background: 'radial-gradient(circle at 30% 30%, #7dffb3, #00ff66 55%, #00993d)',
            boxShadow: '0 0 16px -2px rgba(0,255,102,0.55)',
          }}
        />
        <span className="absolute inset-0 rounded-full border border-white/10" />
      </motion.div>
      {withText && (
        <span className="font-display text-white tracking-tight leading-none" style={{ fontSize: size * 0.65 }}>
          Traders <span style={{ color: '#00ff66' }}>Spring</span> Group
        </span>
      )}
    </div>
  );
}
